export const COOKIE_PERSISTED_CUSTOMER = 'lf_customer_state';
export const COOKIE_AUTHENTICATED = 'lfAuth';
